import { get } from "lodash";
import cx from "classnames";
import React, { useContext, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";

import { fetchDealRoomActiveChatUser, fetchingDealRoomEngageChatUserSucceeded } from "src/redux/actions/dealRoom";
import UserDetails, { PlaceholderUserDetails } from "../userDetails";

import { sendMessage } from "src/legacy/redux/actions/smallTalk";

import { AppContext } from "src/components/app/contexts/appContext";
import { DealRoomContext } from "../../context";
import { guid } from "src/utils/util";

import styles from "./styles.module.scss";
import ChatInput from "./chatInput";
import ChatSection from "./chatSection";
interface ChatContainerProps {
  totalParticipants?: number
}

const ChatContainer: React.FC<ChatContainerProps> = ({ totalParticipants }) => {
  const dispatch = useDispatch();
  const { conversationId } = useParams();
  const chatUserId = conversationId ?? '';
  const { smallTalk } = useContext(AppContext);
  const { dealRoom, everyoneChannel } = useContext(DealRoomContext);
  const dealRoomId = get(dealRoom, 'id', '');
  const canEdit = get(dealRoom, 'canEdit', false);
  const isViewOnly = !canEdit;

  const chatUserData = useSelector((state: any) => {
    return get(state, `dealRooms.dealRoom.${dealRoomId}.engage.activeChatUser`, null);
  });
  const activeChatUser = get(chatUserData, 'item', {});
  const chatUserLoading = get(chatUserData, 'loading', false);

  const channelName = get(activeChatUser, 'uuid', []);

  const me = useSelector((state: any) => {
    return get(state, 'users.me', null);
  });
  const myUuid = get(me, 'id', '');

  const handleSendMessage = (messageText: string) => {

    const request = {
      channel: channelName[0],
      message: {
        id: guid(),
        type: "MESSAGE",
        text: messageText,
        timestamp: new Date().getTime(),
        fingerPrint: "",
        sharedUrl: '',
        sender: {
          chatUser: get(activeChatUser, 'id', ''),
          id: me.id,
          name: `${get(me, 'firstName') || ''} ${get(me, 'lastName') || ''}`,
          type: 'user'
        },
        dealRoomId,
      },
      uuid: myUuid,
    }

    dispatch(sendMessage(smallTalk.client, request) as any);
  }

  useEffect(() => {
    if (chatUserId === everyoneChannel.id) {
      dispatch(fetchingDealRoomEngageChatUserSucceeded({
        response: everyoneChannel,
        dealRoomId
      }));
    } else {
      dispatch(fetchDealRoomActiveChatUser({
        dealRoomId,
        chatUserId
      }));
    }
  }, [chatUserId]);

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        {
          !chatUserLoading ? (
            <UserDetails showMembersCount={true} totalParticipants={totalParticipants} user={activeChatUser} showHighlights={false} />
          ) : (
            <div className={styles.loadingContainer}>
              <PlaceholderUserDetails />
            </div>
          )
        }
      </div>

      <div className={styles.divider}></div>

      <ChatSection />

      {!isViewOnly && <ChatInput />}

      {isViewOnly && (
        <div className={styles.blockedMask} aria-live="polite">
          <span className={styles.blockedMaskHeader}>
            <i className={cx("paperflite-eye", styles.blockedMaskIcon)} />
            <span className={styles.blockedMaskTitle}>View only</span>
          </span>
          <div className={styles.blockedMaskMessage}>
            <span>You have view-only access to this<br /> Deal Room.</span>
          </div>
        </div>
      )}
    </div>
  );
}

export default ChatContainer;